import { createStyles } from '@mantine/core'

export const useStyles = createStyles((theme) => ({
    statChartReleases: {},
    chartWrapper: {
        width: '100%',
    },
}))
